import { useAuth0 } from "@auth0/auth0-react";
import { useAuth } from "../context/authContext";
import { message, Button } from "antd";
import messageTranslations from "../utils/messageContent";
import { useLanguage } from "../context/LanguageContext";

// Lade hier deine Umgebungsvariablea
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useAuthService = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { setIsAuthenticated, fetchUser } = useAuth();
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const resendVerificationEmail = async (email) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/users/resend-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(t.resendError);
      }

      message.success(t.resendSuccess);
    } catch (error) {
      message.error(error.message || t.resendError);
    }
  };

  const loginUser = async (email, password) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        if (
          response.status === 403 &&
          error.message.includes("verify your email")
        ) {
          message.info({
            content: (
              <div>
                {t.verifyPrompt}{" "}
                <Button
                  type="link"
                  onClick={() => resendVerificationEmail(email)}
                >
                  {t.resendBtn}
                </Button>
              </div>
            ),
            duration: 5,
          });
          return;
        }
        throw new Error(error.message || t.loginError);
      }

      const data = await response.json();
      localStorage.setItem("authToken", data.accessToken);
      localStorage.setItem("idToken", data.idToken);
      setIsAuthenticated(true);
      await fetchUser();
      return data;
    } catch (error) {
      message.error({
        content: error.message || t.loginError,
        duration: 5,
      });
      console.error("Login error:", error.message);
    }
  };

  const register = async (nameOrData, email, password) => {
    try {
      let requestBody;

      if (typeof nameOrData === "object" && nameOrData.name) {
        // Neues Format: Objekt mit allen Daten
        requestBody = nameOrData;
      } else {
        // Altes Format: Einzelne Parameter (Backward Compatibility)
        requestBody = {
          name: nameOrData,
          email: email,
          password: password,
        };
      }

      const response = await fetch(`${BACKEND_URL}/api/users/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || t.registerError);
      }

      const data = await response.json();
      message.success(t.registerSuccess);
      return data;
    } catch (error) {
      message.error(error.message || t.registerError);
      console.error("Registration error:", error.message);
    }
  };

  const fetchProfile = async () => {
    const token = await getAccessTokenSilently();

    const response = await fetch(`${BACKEND_URL}/api/users/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Profil konnte nicht geladen werden.");
    }

    return await response.json();
  };

  const userLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("idToken");
    window.location.href = "/login";
  };

  return { loginUser, register, fetchProfile, userLogout };
};
